<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-introduction element-with-heading" id="introduction">
<div class="heading heading-with-title heading-without-image" id="introduction-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Introduction</h1>
</div>
</div>
</div>
</div>
<div class="text" id="introduction-text">
<p class="first first-in-chapter first-full-width">In the sport of golf, a ‘tight lie’ is deemed to be the position (or lie) in which one’s ball has come to rest either upon bare dirt, very short grass, or where there is very little grass beneath the ball. This often makes the connection between the club head and golf ball harder to strike cleanly and therefore the outcome of the intended shot is harder to execute with accuracy.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Tight – (adjective): difficult to deal with or get out of; experiencing a feeling of constriction.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Lie – (noun): a resting position; a false statement made with deliberate intent to deceive; a falsehood.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?74454fde